import TCModal from './TCModal';

export default TCModal;
